/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Messages_Show_MoreInputs */

const en_messages_show_more = /** @type {(inputs: Messages_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`show ${i?.count} more`)
};

const he_messages_show_more = /** @type {(inputs: Messages_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`הצג עוד ${i?.count}`)
};

/**
* | output |
* | --- |
* | "show {count} more" |
*
* @param {Messages_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_show_more = /** @type {((inputs: Messages_Show_MoreInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Show_MoreInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_show_more(inputs)
	return he_messages_show_more(inputs)
});